<template>
    <lay-row space="10">
        <lay-col md="4">
            <lay-panel style="padding: 10px">
                <div>
                    <div>新用户</div>
                    <div class="numericalValue">{{ statistics.newUser }}</div>
                </div>
                <div class="totalVal">
                    <div>总用户：</div>
                    <div>{{ statistics.totalUsers }}</div>
                </div>

            </lay-panel>
        </lay-col>
        <lay-col md="4">
         
                <lay-panel style="padding: 10px">
                    <div>
                        <div>会员</div>
                        <div class="numericalValue">{{ statistics.newMember }}</div>
                    </div>
                    <div class="totalVal">
                        <div>总会员：</div>
                        <div>{{ statistics.totalMembers }}</div>
                    </div>

                </lay-panel>
          
        </lay-col>
        <lay-col md="4"> 
                <lay-panel style="padding: 10px">
                    <div>
                        <div>今日收益</div>
                        <div class="numericalValue">{{ statistics.todayEarnings }}</div>
                    </div>
                    <div class="totalVal">
                        <div>总收益：</div>
                        <div>{{ statistics.totalRevenue }}</div>
                    </div>  
            </lay-panel>
        </lay-col>

        <lay-col md="4"> 
                <lay-panel style="padding: 10px">
                    <div>
                        <div>充值成功</div>
                        <div class="numericalValue">{{ statistics.rechargeSuccessful }}</div>
                    </div>
                    <div class="totalVal">
                        <div>充值失败:</div>
                        <div>{{ statistics.rechargeFailed }}</div>
                    </div> 
            </lay-panel>
        </lay-col>

        <lay-col md="4"> 
                <lay-panel style="padding: 10px">
                    <div>
                        <div>待审核</div>
                        <div class="numericalValue">{{ statistics.pendingReview }}</div>
                    </div>
                    <div class="totalVal">
                        <div>审核失败：</div>
                        <div>{{ statistics.auditFailure }}</div>
                    </div> 
            </lay-panel>
        </lay-col>
        <lay-col md="4"> 
                <lay-panel style="padding: 10px">
                    <div>
                        <div>今日楼凤</div>
                        <div class="numericalValue">{{ statistics.todayLoufeng }}</div>
                    </div>
                    <div class="totalVal">
                        <div>总楼凤：</div>
                        <div>{{ statistics.generalLoufeng }}</div>
                    </div> 
            </lay-panel>
        </lay-col>

       

    </lay-row>


    <lay-row space="10">
        <lay-col md="12">
            <lay-panel style="padding: 10px">
                <lay-table 
                        :page="pagePayLog" 
                        :height="'100%'"
                        :columns="columnsPayLog" 
                        :loading="loading"
                        :default-toolbar="false"
                        :data-source="payLogdataSource" 
                        v-model:selected-keys="selectedKeys"  
                        size="sm"
                        @change="changePayLog"
                        @sortChange="sortChange"> 
                        <template v-slot:toolbar>
                            <h1>充值明显</h1>
                        </template>
                    </lay-table>
            </lay-panel>
        </lay-col>
        <lay-col md="12">
            <lay-panel style="padding: 10px">
                <lay-table 
                        :page="pageAccess"  
                        :height="'100%'"
                        :columns="columnsAccess" 
                        :loading="loading"
                        :default-toolbar="false"
                        :data-source="accessdataSource" 
                        v-model:selected-keys="selectedKeys"  
                         size="sm"
                        @change="changeAccess"
                        @sortChange="sortChange"> 
                        <template v-slot:toolbar>
                            <h1>访问详情数次(按照ip分组)</h1>
                        </template> 
                    </lay-table>
            </lay-panel>
        </lay-col> 
    </lay-row> 
</template>
<script  lang="ts" setup>
import { ref, reactive } from 'vue';
import { layer } from '@layui/layui-vue';
import { allStatistics,allPayLog,allAccessLog } from '../../api' 




const statistics = reactive({
    totalUsers: "0",
    newUser:"0",
    newMember:"0",
    totalMembers:"0",
    todayEarnings:'0',
    totalRevenue:'0',
    rechargeSuccessful:'0',
    rechargeFailed:'0',
    pendingReview:'0',
    auditFailure:'0',
    todayLoufeng:'0',
    generalLoufeng:'0',
})

 


const getAllStatistics=()=>{

    allStatistics().then((res: any) => {
    if (res != "" && res.code == 0) {  
        statistics.newUser=res.data.newUser;
        statistics.totalUsers=res.data.totalUsers;
        statistics.newMember=res.data.newMember;
        statistics.totalMembers=res.data.totalMembers;
        statistics.todayEarnings=res.data.todayEarnings; 
       statistics.totalRevenue=res.data.totalRevenue; 
       statistics.rechargeSuccessful=res.data.rechargeSuccessful; 
       statistics.rechargeFailed=res.data.rechargeFailed; 
       statistics.pendingReview=res.data.pendingReview; 
       statistics.auditFailure=res.data.auditFailure; 
       statistics.todayLoufeng=res.data.todayLoufeng; 
       statistics.generalLoufeng=res.data.generalLoufeng;  
        
    }
  })

}

getAllStatistics();






const pageAccess = reactive({ current: 1, limit: 10, total: 0 });


const columnsAccess = ref([ 
      { title:"平台", width: "80px", key:"platformId",align:"center" },
      { title:"ip", key:"userName" ,align:"center" }, 
      { title:"账号", key:"userId" ,align:"center" }, 
      { title:"次数", width: "120px", key:"count" ,align:"center" },  
      { title:"时间", key:"addTime" ,align:"center"},
     
    ]);

    const accessdataSource = ref( )


    const changeAccess = (page:any) => {
        getAllAccessLog()
    }

    

    const  getAllAccessLog=()=>{
    var data = { "page": pageAccess.current, "limit": pageAccess.limit};
    allAccessLog(data).then((res: any) => {
    if (res != "" && res.code == 0) {  
        accessdataSource.value=res.data

        pageAccess.total = res.count;
        loading.value = false;
 
        
    }else {
        accessdataSource.value = [];
        pageAccess.total = 0;
              loading.value = false;
            }
  })

   }


   getAllAccessLog()


const loading = ref(false); 
    const selectedKeys = ref([]);

    const pagePayLog = reactive({ current: 1, limit: 10, total: 0 });

    const columnsPayLog = ref([ 
      { title:"平台", width: "80px", key:"platformId",align:"center" },
      { title:"账号", key:"userName" ,align:"center" }, 
      { title:"订单编号", key:"orderid" ,align:"center" }, 
      { title:"金额", width: "120px", key:"amount", sort: "desc" ,align:"center" },  
      { title:"时间", key:"dateTime" ,align:"center"},
     
    ]);

    const changePayLog = (page:any) => {
        getAllPayLog()
    }

    const sortChange = (key:any, sort:any) => {
      layer.msg(`字段${key} - 排序${sort}, 你可以利用 sort-change 实现服务端排序`)
    }

    const payLogdataSource = ref( )

   const  getAllPayLog=()=>{
    var data = { "page": pagePayLog.current, "limit": pagePayLog.limit, "state": 2};
    allPayLog(data).then((res: any) => {
    if (res != "" && res.code == 0) {  
        payLogdataSource.value=res.data

        pagePayLog.total = res.count;
        loading.value = false;
 
        
    }else {
        payLogdataSource.value = [];
        pagePayLog.total = 0;
              loading.value = false;
            }
  })

   }


   getAllPayLog()

 

 
</script>

<style scoped>
.numericalValue {
    margin-top: 10px;
    font-size: 20px;
}

.totalVal {
    display: flex;
    font-size: 14px;
    margin-top: 5px;
    flex-wrap: nowrap;
    align-content: space-between;
    justify-content: center;
    align-items: center;
}
</style>

 